import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CoinService} from '../../../../../common/services/coin.service';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../../../../_services/auth.service';
import {Title} from '@angular/platform-browser';
import {GeneralService} from '../../../../../_services/general.service';
import {SeoService} from '../../../../../common/services/set.service';
import {SubjectsService} from '../../../../../_services/subjects.service';

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

@Component({
  selector: 'app-view-coin',
  templateUrl: './view-coin.component.html',
  styleUrls: ['./view-coin.component.css']
})
export class ViewCoinComponent implements OnInit, OnDestroy {

  getCoin: any;
  coin: any = {};
  loading = false;
  copied = false;
  loader = false;
  voteCoin: any;
  voted = false;
  coins: any = [];
  isLogged: boolean | undefined;
  errorMessage: string | null | undefined;
  resendEmail$: any;
  user: any = {};
  coins$: any;

  countDownConfing: any = {
    format: 'HH:mm:ss'
  };

  constructor(
    private coinService: CoinService,
    private seoService: SeoService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService,
    private titleService: Title,
    private subjectsService: SubjectsService
  ) {
    // this.titleService.setTitle('CoinCatapult - Coin page');
  }

  ngOnInit() {
    this.isLogged = this.authService.authenticated();
    this.user = this.authService.getUser() || {};
    const slug = this.route.snapshot.paramMap.get('slug');

    if (slug) {
      this.getObject(slug);
    }
    const self = this;
    this.coins$ = this.subjectsService.coins.subscribe(function(val) {
      if (val) {
        self.parseCoins(val);
      }
    });
    this.subjectsService.getMarketingCoins.next(true);
  }

  handleEvent(event: { action: string; }) {
    if (event.action == 'done') {
      this.coin.timeToVote = 0;
    }
  }

  getObject(slug: string) {
    this.loading = true;
    this.getCoin = this.coinService.getObject(slug)
      .subscribe(
        (res: any) => {
          if (res.response) {
            this.coin = res.response;
            if (this.coin.meta) {
              this.seoService.setTitle(this.coin.meta.title);
            }

            const self = this;
            const votes = JSON.parse(localStorage.getItem('votes') as string);
            const date = new Date();
            if (votes && !this.isEmpty(this.user)) {
              const vote = JSON.parse(JSON.stringify(votes)).filter(function(item: { id: any; userID: any; }) {
                if (item.id == self.coin.id && item.userID == self.user.id) {
                  return item;
                }
              });

              if (vote.length == 0) {
                this.coin.timeToVote = 0;
              } else {
                if ((date.getTime() / 1000 - vote[0].timestamp) < 21600) {
                  this.coin.timeToVote = 21600 - (date.getTime() / 1000 - vote[0].timestamp);
                } else {
                  this.coin.timeToVote = 0;
                }
              }
            } else {
              this.coin.timeToVote = 0;
            }
          } else if (res.error_code.code == 9000) {
            this.router.navigate(['/']);
          } else {
            this.toastr.error(res.error_code.message);
          }
          this.loading = false;
        },
        (error) => {
          this.toastr.error(error);
          this.loading = false;
        }
      );
  }

  parseCoins(coins: any) {
    this.coins = JSON.parse(JSON.stringify(coins)).filter(function(item: { status: number; }) {
      if (item.status == 2) {
        return item;
      }
    });
  }

  resendEmail() {
    this.resendEmail$ = this.authService.resendActivationEmail()
      .subscribe(
        (data: any) => {
          if (data.error_code.code == 0) {
            this.toastr.success('Success! Verify your email!');
            this.errorMessage = null;
          } else {
            this.toastr.error(data.error_code.message);
          }
        },
        (error: any) => {
          this.toastr.error(error);
        });
  }

  isEmpty(obj: {}) {
    return Object.keys(obj).length === 0;
  }

  handleEventList(event: { action: string; }, coin: { timeToVote: number; }) {
    if (event.action == 'done') {
      coin.timeToVote = 0;
    }
  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    const self = this;

    if (!this.copied) {
      this.copied = true;
      setTimeout(() => {
        self.copied = false;
      }, 2000);
    }

  }

  transformDate(date: string) {
    let d = new Date(date.replace('Z', '')),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }
    return day + ' ' + months[d.getMonth()] + ' ' + year;
  }

  vote() {
    if (this.voteCoin) {
      this.voteCoin.unsubscribe();
    }
    this.loader = true;
    this.voteCoin = this.coinService.vote({coin: this.coin.slug})
      .subscribe(
        (res: any) => {
          if (res.error_code.code == 0) {
            this.coin.votes += 1;
            this.coin.votesToday += 1;
            const self = this;
            let votes = JSON.parse(localStorage.getItem('votes') as string);
            const date = new Date();
            if (votes) {
              const vote = votes.filter(function(item: { id: any; userID: any; }) {
                if (item.id == self.coin.id && item.userID == self.user.id) {
                  return item;
                }
              });

              if (vote.length == 0) {
                votes.push({id: this.coin.id, timestamp: date.getTime() / 1000, userID: this.user.id});
              } else {
                vote[0].timestamp = date.getTime() / 1000;
              }
            } else {
              votes = [];
              votes.push({id: this.coin.id, timestamp: date.getTime() / 1000, userID: this.user.id});
            }
            localStorage.setItem('votes', JSON.stringify(votes));
            this.coin.timeToVote = 21600;
            this.toastr.success('Thank you for your vote!');
          } else if (res.error_code.code == 2000) {
            this.errorMessage = 'Verify email address in order to activate your account.';
            // @ts-ignore
            document.querySelector('.errorMessageTop').scrollIntoView({
              behavior: 'smooth'
            });
            this.toastr.error(res.error_code.message);
          } else {
            this.toastr.error(res.error_code.message);
          }
          this.loader = false;
        },
        (error) => {
          this.toastr.error(error);
          this.loader = false;
        }
      );
  }

  navigate(coin: { slug: string; }) {
    this.redirectTo('coin/' + coin.slug);
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => this.router.navigate([uri]));
  }

  trackByIndex(index: any) {
    return index;
  }

  isNumberContract(coin: { contract: string; }) {
    const regex = new RegExp(/[a-z]/i);
    if (regex.test(coin.contract)) {
      return false;
    } else {
      return true;
    }
  }

  ngOnDestroy(): void {

    if (this.getCoin) {
      this.getCoin.unsubscribe();
    }

    if (this.coins$) {
      this.coins$.unsubscribe();
    }

    if (this.voteCoin) {
      this.voteCoin.unsubscribe();
    }

    if (this.resendEmail$) {
      this.resendEmail$.unsubscribe();
    }

  }

}
